import type { Theme } from '@mui/material/styles';
import type { SxProps, SystemStyleObject } from '@mui/system';

/** Decorative preview boards must not intercept taps meant for a parent link or row. */
export const nonInteractivePreviewBoardShellSx = (
  boardWidth: number | string,
): SxProps<Theme> => ({
  width: boardWidth,
  height: boardWidth,
  flexShrink: 0,
  position: 'relative',
  borderRadius: 0.5,
  overflow: 'hidden',
  pointerEvents: 'none',
  touchAction: 'none',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  WebkitTouchCallout: 'none',
  '& *': {
    pointerEvents: 'none',
    touchAction: 'none',
  },
});

/** Relative wrapper for a preview board plus optional tap-capture overlay. */
export const previewBoardTapCaptureContainerSx: SystemStyleObject<Theme> = {
  position: 'relative',
  width: '100%',
  minWidth: 0,
};

/**
 * Transparent layer over animated boards so parent card/row links receive
 * the full tap on touch devices (react-chessboard can still capture touches).
 */
export const previewBoardTapCaptureOverlaySx: SystemStyleObject<Theme> = {
  position: 'absolute',
  inset: 0,
  zIndex: 1,
};
